import React from "react"

import style from "./index.module.sass"

export default function ItemPrice(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { className, originalPriceCents, priceCents } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  function getHumanPrice(cents) {
    return (cents / 100.0).toFixed(2) + " €"
  }

  function renderDiscountedPrice() {
    return (
      <div className={`${style.price} ${className}`}>
        <span className={style.strikethroughPrice}>
          {getHumanPrice(originalPriceCents)}
        </span>
        <span>{getHumanPrice(priceCents)}</span>
      </div>
    )
  }

  function renderPrice() {
    return (
      <div className={`${style.price} ${className}`}>
        <span>{getHumanPrice(priceCents)}</span>
      </div>
    )
  }

  // -------------------------------------

  return originalPriceCents ? renderDiscountedPrice() : renderPrice()
}
